export function bindViewportUnit(host: HTMLElement): () => void {
  const update = () => {
    const vh = window.visualViewport?.height ?? window.innerHeight;
    host.style.setProperty('--cg-vh', `${vh * 0.01}px`);
  };

  update();
  window.visualViewport?.addEventListener('resize', update);
  window.addEventListener('resize', update);

  return () => {
    window.visualViewport?.removeEventListener('resize', update);
    window.removeEventListener('resize', update);
  };
}
